import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { reviewCvFile } from '../server/reviewCvFile.js';

export const reviewCvFileQuery = registerQuery({
  type: () => String,
  operationName: 'reviewCvFile',
  resolve: (resumeFileId: string) => {
    return async () => {
      return await reviewCvFile(resumeFileId);
    };
  },
  params: [{ type: () => String, name: 'resumeFileId' }],
});
